import { ReactNode } from 'react';
import { AssistantChatResult, AssistantCommandResult } from '@mews-commander/data-access';
import { Typography } from '@optimus-web/core';
import { AssistantMessageBox } from '../../chat/components/AssistantMessageBox';
import { AssistantCommandBox } from '../../chat/components/AssistantCommandBox';
import { DrawerContentContainer, DrawerSmartResultContentContainer } from './styles';

export interface DrawerChatResultContentProps {
    chatResult: AssistantChatResult;
    searchTerm: string;
    showFollowUp: boolean;
    handleUnFocused: () => void;
}

export interface DrawerSmartSearchResultContentProps {
    searchResultListComponent: ReactNode;
    description?: string;
}

export const DrawerSearchResultContent = ({ searchResultListComponent }: { searchResultListComponent: ReactNode }) => (
    <DrawerContentContainer>{searchResultListComponent}</DrawerContentContainer>
);

export const DrawerCommandResultContent = ({ commandResult }: { commandResult: AssistantCommandResult }) => (
    <DrawerContentContainer>
        <AssistantCommandBox commandResult={commandResult} />
    </DrawerContentContainer>
);

export const DrawerSmartSearchResultContent = ({
    searchResultListComponent,
    description,
}: DrawerSmartSearchResultContentProps) => (
    <DrawerSmartResultContentContainer>
        {description && (
            <Typography textStyle="bodyLarge" variant="secondary" as="div">
                {description}
            </Typography>
        )}
        {searchResultListComponent}
    </DrawerSmartResultContentContainer>
);

export const DrawerChatResultContent = ({
    chatResult,
    showFollowUp,
    searchTerm,
    handleUnFocused,
}: DrawerChatResultContentProps) => (
    <DrawerContentContainer>
        <AssistantMessageBox
            chatResult={chatResult}
            showFollowUp={showFollowUp}
            searchTerm={searchTerm}
            handleUnFocused={handleUnFocused}
        />
    </DrawerContentContainer>
);
export const DrawerRecentAndFavoriteResultContent = ({
    resentAndFavoriteListComponent,
}: {
    resentAndFavoriteListComponent: ReactNode;
}) => <DrawerContentContainer>{resentAndFavoriteListComponent}</DrawerContentContainer>;
